import { Injectable } from '@angular/core';
import { Item } from '@domains';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ItemService } from '@rspl-api';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as fromActions from './item.actions';

@Injectable()
export class ItemEffects {
  getItems = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getItems),
      switchMap((params) =>
        this.service.filter(params.findParams).pipe(
          map((results) => {
            return fromActions.getItemsSuccess({
              resultsCount: results.totalResults,
              results: results.results.map((p) => new Item(p)),
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  getItem = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getItem),
      switchMap((params) =>
        this.service.find(params.id, (params.expand?.length || 0) > 0, params.expand).pipe(
          map((result) => {
            return fromActions.getItemSuccess({
              item: new Item(result),
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private service: ItemService,
  ) {}
}
